import { Layout } from 'antd';
import { BrowserRouter as Router } from 'react-router-dom';
import styled from 'styled-components';
// stylesheet
import './styles/App.css';

import { useAppSelector } from './app/hooks';
import { RootState } from './app/store';

import { SideNavbar } from './components/common/sideNavbar/SideNavbar';
import { ReleaseNotesPopup } from './components/common/releaseNotes/ReleaseNotesPopup';
// import { BrandingLoading } from './components/BrandingLoading';

import { sideNavbarItens } from './menuItens';
import { Routes } from './routes';

import GlobalStyle from './styles/globalStyles';

import { BrandingProvider, useBranding } from './context/brandingContext';

const Content = styled(Layout.Content)`
  background-color: var(--neutral_lightest);
`;

function AppContent(): JSX.Element {
  const { token } = useAppSelector((state: RootState) => state.auth);

  return (
    <>
      <GlobalStyle />

      <Layout style={{ minHeight: '100vh' }} hasSider>
        <Router>
          {token && <SideNavbar navbarItens={sideNavbarItens} />}
          {token && <ReleaseNotesPopup />}

          <Content>
            <Routes />
          </Content>
        </Router>
      </Layout>
    </>
  );
}

function App(): JSX.Element {
  return (
    <BrandingProvider>
      <AppContent />
    </BrandingProvider>
  );
}

export default App;
